import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import filter from 'ramda/src/filter';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import ProgressBar from '@components/@core/ProgressBar';
import AppActions from '~/actions/app';
import { ProgramTypes } from '~/services/config';

const CareerManagement = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const users = useSelector((state) => state.app.users);
    const reports = useSelector((state) => state.manage.managerDashboard);
    const { average_completion, employee_careers, promotions_possible, top_users } = reports.career;
    const disabled = filter((e) => e !== 'careers', ProgramTypes);

    const handleModal = () => {
        const payload = { type: 'Assign Program', data: { before: { disabled } } };
        dispatch(AppActions.modalRequest(payload));
    };

    return (
        <div className="card mb-3 custom-width">
            <p className="dsl-b22 bold">Health Plan Management</p>
            <div className="d-flex">
                <div className="career-card me-3 text-center py-2 px-1">
                    <p className="dsl-m12 text-400 mb-0">Employees</p>
                    <p className="dsl-m12 text-400 mb-2">Health Plan Paths</p>
                    <p className="dsl-b16 text-400 mb-0">{employee_careers}</p>
                </div>
                <div className="career-card me-3 text-center py-2 px-1">
                    <p className="dsl-m12 text-400 mb-0">Promotions</p>
                    <p className="dsl-m12 text-400 mb-2">Possible this Month</p>
                    <p className="dsl-b16 text-400 mb-0">{promotions_possible}</p>
                </div>
                <div className="career-card text-center py-2 px-1">
                    <p className="dsl-m12 text-400 mb-0">Ave Career</p>
                    <p className="dsl-m12 text-400 mb-2">Completion</p>
                    <p className="dsl-b16 text-400 mb-0">{average_completion}%</p>
                </div>
            </div>
            <p className="dsl-b18 bold mt-4">Health Plan Progress</p>
            <div className="px-0 px-md-3">
                {top_users.length > 0 ? (
                    top_users.map((item, index) => {
                        const user = find(propEq('id', item.user.id), users);
                        return (
                            <div className="d-flex ai-center mt-3" key={`cm${index}`}>
                                <Avatar className="mr-4" name={`${item.user.profile.first_name} ${item.user.profile.last_name}`} url={user?.avatar || item.user.profile.avatar} />
                                <ProgressBar className="d-flex-1" title={item.program.title} value={item.completed_percent} />
                            </div>
                        );
                    })
                ) : (
                    <p className="dsl-m12 text-center mt-3">No career progress</p>
                )}
            </div>
            <div className="justify-end mt-3">
                <Button className="text-400 me-2" type="low" name="ASSIGN CAREER" onClick={handleModal} />
                <Button className="text-400" type="medium" name="CAREER REPORT" onClick={() => navigate('/hcm/report-careers')} />
            </div>
        </div>
    );
};

export default memo(CareerManagement);
